// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"794":"css/admin-app.6951","2678":"css/app.6951"}[chunkId] + ".css";
};